import React from "react";
import { Modal } from "antd";
import { scrollTriggerIntoView } from '../../util/modalUtils';
import { useModalWidth } from '../../hooks/useModalWidth';
import SuccessImg from '../../assets/UiElements/correct.svg';

// Props: visible, onClose, title, subTitle, closeText
export default function LinkSuccessModal({ visible, onClose, title = "Link Successful", subTitle = "Your account has been linked successfully.", closeText = "Close" }) {
  const modalWidth = useModalWidth();
  
  React.useEffect(() => { if (visible) scrollTriggerIntoView(); }, [visible]);

  return (
    <Modal
      centered
      open={visible}
      destroyOnClose={true}
      closable={false}
      footer={null}
      onCancel={onClose}
      width={modalWidth}
      zIndex={4000}
    >
      <div className="p-5">
        <div className="success-modal" style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: 16 }}>
            <img src={SuccessImg} alt="Success" style={{ width: 80, height: 80 }} />
          </div>
          <p className="lead mt-4" style={{ fontWeight: 700, fontSize: 20, margin: '24px 0 8px 0' }}>{title}</p>
          <p className="text-black-50" style={{ color: '#555', marginBottom: 24 }}>{subTitle}</p>
          <button className="btn btn-primary mb-4 w-50 mobile-full-width" onClick={onClose}>{closeText}</button>
        </div>
      </div>
    </Modal>
  );
}
